import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { FileUploadEnergyType } from '../../../../core/interfaces/file-upload-interfaces';

@Component({
  selector: 'app-energy-type-text',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './energy-type-text.component.html',
  styleUrl: './energy-type-text.component.css'
})
export class EnergyTypeTextComponent {
  @Input() energyType?: FileUploadEnergyType | null;
  EnergyType = FileUploadEnergyType;
}
